import { PaginationState } from "@tanstack/react-table";
import BreadCrumb from "Common/BreadCrumb";
import TableContainer from "Common/TableContainer";
import callApi from "Common/utils/apiCaller";
import { getImageUrl } from "../../Common/utils/ImageDomain";
import {
  Download,
  Plus,
  Search,
  SlidersHorizontal,
  X,
  Rows4,
  GridIcon,
} from "lucide-react";
import moment from "moment";
import PaginationContainer from "../media/PaginationContainer";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import { Pencil, Trash2 } from "lucide-react";
import Drawer from "Common/Components/Drawer";
import _ from "lodash";
import DeleteModal from "Common/DeleteModal";
import { TailSpin } from "react-loader-spinner";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";
import { UploadCloud } from "lucide-react";
import axios from "axios";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { iconUploader } from "Common/utils/imageUploader";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";

const IconList = () => {
  const [mediaData, setMediaData] = useState([]);
  const [loader, setLoader] = useState<any>(false);
  const [selectedFile, setSelectedFile] = useState<any>();
  const [search, setSearch] = useState<any>();
  const [showTable, setShowTable] = useState<any>(true);
  const [pageCount, setPageCount] = useState(0);
  const [eventData, setEventData] = useState<any>();
  const [show, setShow] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [totalItems, setTotalItems] = useState(0);
  const [render, setRender] = useState(false);

  const [pagination, setPagination] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const deleteToggle = () => setDeleteModal(!deleteModal);

  const activeStyle =
    "bg-custom-700 border-custom-700 hover:bg-custom-800 hover:border-custom-800";
  const inactiveStyle =
    "bg-custom-400 border-custom-400 hover:bg-custom-600 hover:border-custom-600";

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      user: profile.user,
      error: profile.error,
      success: profile.success,
      permission: profile.permission,
    })
  );

  const { error, success, user, permission } = useSelector(selectProperties);

  // Pagination

  const [page, setPage] = useState<PaginationState>({
    pageIndex: 0,
    pageSize: 30,
  });

  //fetch media
  const debouncedHandler = useCallback(
    _.debounce((search: any, pagination: any, render: any) => {
      return fetchDateWithFilters(search, pagination, render);
    }, 700),
    []
  );
  async function fetchDateWithFilters(
    search: any,
    pagination: any,
    render: any
  ) {
    let filters: { [index: string]: any } = {};

    if (search) {
      filters.qtext = search;
    }
    const localData = await callApi("v1/icon/list", "post", {
      pageNum: pagination?.pageIndex + 1,
      pageSize: pagination?.pageSize,
      filters,
    });

    if (localData?.status === "Success") {
      setMediaData(localData?.data?.iconList);
      setPageCount(
        Math.ceil(localData?.data?.iconCount / pagination?.pageSize)
      );
      setTotalItems(localData?.data?.iconCount);
    }
  }

  interface PermissionInfo {
    permissions: string[];
  }

  const rawPermission = localStorage.getItem("permission");
  const premissionInfo: PermissionInfo | null = rawPermission
  ? JSON.parse(rawPermission)
  : null;

  const filterSearchData = (e: any) => {
    const search = e.target.value;
    setSearch(search);
  };

  useEffect(() => {
    debouncedHandler(search, pagination, render);
  }, [search, pagination, render]);
  // Delete Data
  const onClickDelete = (cell: any) => {
    setDeleteModal(true);
    if (cell._id) {
      setEventData(cell);
    }
  };

  const handleDelete = async () => {
    if (eventData) {
      const res = await callApi(`v1/icon/${eventData?._id}/remove`, "post", {});
      if (res && res?.status === "Success") {
        setDeleteModal(false);
        setRender(!render);
        toast("Deleted successfully");
      }
    }
  };

  // Update Data
  const handleUpdateDataClick = (ele: any) => {
    setEventData({ ...ele });

    setLoader(false);
    setIsEdit(true);
    setShow(true);
  };

  const handleMedia = async (data: any) => {
    if (isEdit) {
      // update user
      // let image = "";
      // var bodyFormData = new FormData();
      // bodyFormData.append("file", selectedFile);
      // setLoader(true);
      // const ress = await imageUploader(file, user);
      // setLoader(false);
      // if (ress.status === "Success") {
      //   toast("Media Uploaded");
      //   image = ress.data.data.link;
      //   setRender(!render);
      // } else {
      //   toast("something went wrong");
      // }
      // try {
      //   const res = await callApi(`v1/icon/${eventData?._id}/update`, "post", {
      //     icon: {
      //       icon_url: image,
      //       icon_type: "image",
      //       content_type: selectedFile?.type,
      //       file_name: selectedFile?.name,
      //     },
      //   });
      //   if (res && res?.status === "Success") {
      //     setRender(!render);
      //     toast("Updated successfully");
      //     setSelectedFile(undefined);
      //   }
      // } catch (e) {
      //   toast("something went wrong");
      // }
    } else {
      setLoader(true);
      const ress = await iconUploader(selectedFile, user);
      setLoader(false);
      if (ress.status === "Success") {
        toast("Icon Uploaded");
        setRender(!render);
      } else {
        toast("something went wrong");
      }
    }
    toggle();
  };

  // validation
  const validation: any = useFormik({
    enableReinitialize: true,
    initialValues: {
      selectedFile: selectedFile || "",
    },
    validationSchema: Yup.object().shape({
      selectedFile: Yup.string().required("Media File is required."),
    }),
    onSubmit: (values) => {
      handleMedia(values);
    },
  });

  const toggle = useCallback(() => {
    if (show) {
      setShow(false);
      setEventData("");
      setIsEdit(false);

      setSelectedFile("");
      setLoader(false);
    } else {
      setShow(true);
      setSelectedFile("");
      setEventData("");

      validation.resetForm();
    }
  }, [show, validation]);

  const handleAcceptedFiles = async (file: any) => {
    Object.assign(file, {
      preview: URL.createObjectURL(file),
      formattedSize: formatBytes(file.size),
    });
    setSelectedFile(file);
  };
  const formatBytes = (bytes: any, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  const mediaListColumns = useMemo(
    () => [
      {
        header: "File Name",
        accessorKey: "file_name",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Icon Type",
        accessorKey: "icon_type",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Icon Url",
        // accessorKey: "icon_url",
        enableColumnFilter: false,
        enableSorting: false,
        cell: (cell: any) => {
          return (
            <div>
              {cell.row.original.icon_url !== "" ? (
                <Link
                  to={getImageUrl(cell.row.original.icon_url)}
                  className="flex items-center gap-3"
                  target="_blank"
                >
                  <div className="rounded-full size-6 shrink-0 bg-slate-100">
                    {cell.row.original.icon_url ? (
                      <img
                        src={getImageUrl(cell.row.original.icon_url)}
                        alt="img"
                        className="size-6"
                      />
                    ) : null}
                  </div>
                </Link>
              ) : (
                <div className="flex items-center gap-3">
                  {" "}
                  <div className="rounded-full size-6 shrink-0 bg-slate-100"></div>
                </div>
              )}
            </div>
          );
        },
      },
      {
        header: "Content Type",
        accessorKey: "content_type",
        enableColumnFilter: false,
        enableSorting: false,
      },
      {
        header: "Action",
        enableColumnFilter: false,
        enableSorting: true,
        cell: (cell: any) => (
          <div className="flex gap-3">
            {/* <PermissionSwitch
              hasPermissions={permission.permissions}
              shouldHavePermissions={["icon:edit"]}
              yes={
                <Link
                  to="#!"
                  data-modal-target="addEmployeeModal"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 edit-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    handleUpdateDataClick(data);
                  }}
                >
                  <Pencil className="size-4" />
                </Link>
              }
              no={<span></span>}
            /> */}
            <PermissionSwitch
               hasPermissions={premissionInfo?.permissions ?? []}
              shouldHavePermissions={["icon:delete"]}
              yes={
                <Link
                  to="#!"
                  className="flex items-center justify-center transition-all duration-200 ease-linear rounded-md size-8 remove-item-btn bg-slate-100 text-slate-500 hover:text-custom-500 hover:bg-custom-100 dark:bg-zink-600 dark:text-zink-200 dark:hover:bg-custom-500/20 dark:hover:text-custom-500"
                  onClick={() => {
                    const data = cell.row.original;
                    onClickDelete(data);
                  }}
                >
                  <Trash2 className="size-4" />
                </Link>
              }
              no={<span></span>}
            />
          </div>
        ),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <BreadCrumb title="Icon List" pageTitle="Icon List" version="" />
      <DeleteModal
        show={deleteModal}
        onHide={deleteToggle}
        onDelete={handleDelete}
      />
      <ToastContainer closeButton={false} limit={1} />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="card-body">
            <div className="flex items-center">
              <h6 className="text-15 grow">Icon List</h6>
              <div className="shrink-0">
                <PermissionSwitch
                 hasPermissions={premissionInfo?.permissions ?? []}
                  shouldHavePermissions={["icon:create"]}
                  yes={
                    <button
                      type="button"
                      className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={toggle}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Icon</span>
                    </button>
                  }
                  no={
                    <button
                      type="button"
                      disabled={true}
                      className="text-grey btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      onClick={null}
                    >
                      <Plus className="inline-block size-4" />{" "}
                      <span className="align-middle">Add Icon</span>
                    </button>
                  }
                />
              </div>
            </div>
          </div>
          <div className="!py-3.5 card-body border-y border-dashed border-slate-200 dark:border-zink-500">
            <form action="#!">
              <div className="grid grid-cols-1 gap-5 xl:grid-cols-12">
                <div className="relative flex justify-around xl:col-span-3">
                  <span
                    style={{
                      cursor: "pointer",
                      marginRight: "3px",
                    }}
                    className={`text-white btn ${
                      showTable ? activeStyle : inactiveStyle
                    } focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20`}
                    onClick={() => setShowTable(true)}
                  >
                    <span
                      style={{
                        display: "flex",
                        whiteSpace: "nowrap",
                        alignItems: "center",
                      }}
                    >
                      <Rows4 style={{ paddingRight: "5px" }} />
                      Table View
                    </span>
                  </span>

                  <span
                    style={{ cursor: "pointer" }}
                    className={`text-white btn ${
                      !showTable ? activeStyle : inactiveStyle
                    } focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20`}
                    onClick={() => setShowTable(false)}
                  >
                    <span
                      style={{
                        display: "flex",
                        whiteSpace: "nowrap",
                        alignItems: "center",
                      }}
                    >
                      <GridIcon style={{ paddingRight: "5px" }} />
                      Grid View
                    </span>
                  </span>
                </div>

                <div className="relative xl:col-span-2">
                  <input
                    type="text"
                    className="ltr:pl-8 rtl:pr-8 search form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Search for content type"
                    autoComplete="off"
                    onChange={(e) => filterSearchData(e)}
                  />
                  <Search className="inline-block size-4 absolute ltr:left-2.5 rtl:right-2.5 top-2.5 text-slate-500 dark:text-zink-200 fill-slate-100 dark:fill-zink-600" />
                </div>
              </div>
            </form>
          </div>
          <div className="card-body">
            {showTable ? (
              <TableContainer
                isPagination={true}
                columns={mediaListColumns || []}
                data={mediaData || []}
                pageCount={pageCount}
                pagination={pagination}
                totalItems={totalItems}
                onPaginationChange={(updater: any) => {
                  const nextState = updater(pagination);
                  if (nextState?.pageIndex !== pagination?.pageIndex)
                    setPagination(nextState);
                }}
                divclassName="overflow-x-auto"
                tableclassName="w-full whitespace-nowrap"
                theadclassName="ltr:text-left rtl:text-right bg-slate-100 text-slate-500 dark:text-zink-200 dark:bg-zink-600"
                thclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 font-semibold border-y border-slate-200 dark:border-zink-500"
                tdclassName="px-3.5 py-2.5 first:pl-5 last:pr-5 border-y border-slate-200 dark:border-zink-500"
                PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
              />
            ) : (
              <>
                <div className="grid grid-cols-2 gap-4 mt-2 mb-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 auto-rows-max">
                  {mediaData?.map((item: any) => (
                    <div
                      className="relative"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                      key={item._id}
                      // onClick={() => {
                      //   setEventData(item);
                      //   setIsEdit(true);
                      //   setShow(true);
                      // }}
                    >
                      {item.icon_url ? (
                        <img
                          src={getImageUrl(item.icon_url)}
                          alt="img"
                          className="w-40 h-40 rounded"
                        />
                      ) : null}
                    </div>
                  ))}
                </div>
                <PaginationContainer
                  isPagination={true}
                  data={mediaData || []}
                  pageCount={pageCount}
                  pagination={pagination}
                  totalItems={totalItems}
                  onPaginationChange={(updater: any) => {
                    const nextState = updater(pagination);
                    if (nextState?.pageIndex !== pagination?.pageIndex)
                      setPagination(nextState);
                  }}
                  divclassName="overflow-x-auto"
                  PaginationClassName="flex flex-col items-center mt-5 md:flex-row"
                />
              </>
            )}
          </div>
        </div>
      </div>
      {/* Employee Modal */}
      <Drawer
        show={show}
        onHide={toggle}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {!!isEdit ? "Edit Icon" : "Add Icon"}
          </Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <form
            className="create-form"
            id="create-form"
            onSubmit={(e) => {
              e.preventDefault();
              validation.handleSubmit();
              return false;
            }}
          >
            <input type="hidden" value="" name="id" id="id" />
            <input type="hidden" value="add" name="action" id="action" />
            <input type="hidden" id="id-field" />
            <div
              id="alert-error-msg"
              className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
            ></div>
            <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
              <div className="xl:col-span-12">
                {validation.touched.selectedFile &&
                validation.errors.selectedFile ? (
                  <p className="text-red-400">
                    {validation.errors.selectedFile}
                  </p>
                ) : null}
              </div>
              <div className="xl:col-span-12">
                <h6 className="mb-4 text-15">Upload Icon</h6>
                {selectedFile ? (
                  <div className="flex items-center">
                    <div className="relative w-40 h-40 ">
                      <img
                        data-dz-thumbnail
                        className="rounded border-[gray] border"
                        style={{
                          objectFit: "contain",
                          width: "100%",
                          height: "100%",
                        }}
                        src={selectedFile?.preview}
                        alt={"img"}
                      />
                      <span
                        style={{
                          position: "absolute",
                          top: "0px",
                          right: "6px",
                          fontSize: "22px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          setSelectedFile(null);
                        }}
                      >
                        ×
                      </span>
                    </div>
                    <div className="h-3 ml-3">
                      <input
                        type="file"
                        hidden
                        id="uploadimage49"
                        accept="image/*"
                        className="hidden profile-img-file-input"
                        onChange={(e: any) =>
                          handleAcceptedFiles(e.target.files[0])
                        }
                      />
                      <label
                        htmlFor="uploadimage49"
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </label>
                    </div>
                  </div>
                ) : (
                  <div className="mt-3">
                    <input
                      type="file"
                      hidden
                      id="uploadimage59"
                      accept="image/*"
                      className="hidden profile-img-file-input"
                      onChange={(e: any) =>
                        handleAcceptedFiles(e.target.files[0])
                      }
                    />
                    <label
                      htmlFor="uploadimage59"
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Icon"}
                    </label>
                  </div>
                )}
              </div>
            </div>
            <div className="flex justify-end gap-2 mt-4">
              <button
                type="reset"
                id="close-modal"
                data-modal-close="addEmployeeModal"
                className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                onClick={toggle}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={loader}
                style={{
                  minWidth: "130px",
                  display: "flex",
                  justifyContent: "center",
                }}
                id="addNew"
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                {loader ? (
                  <span>
                    <TailSpin
                      visible={true}
                      height="20"
                      width="20"
                      color="#fff"
                    />
                  </span>
                ) : !!isEdit ? (
                  "Update "
                ) : (
                  "Add"
                )}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>
    </React.Fragment>
  );
};

export default IconList;
